// Tokens de UI do modulo Auditoria Inteligente — fonte unica de cor.
//
// Alinhados a paleta global do Indicadores (src/theme/colors.ts) para reconciliar
// a marca (azul = primary; ink = text.primary; etc.). Regra de cor (mesma do
// modulo Financeiro): verde/vermelho/ambar carregam SIGNIFICADO (ok/erro/atencao);
// a cor de AREA (roxo) vive so no header/badge do modulo — nunca pinta numero nem
// barra de dado, para a cor sempre informar.
export const UI = {
  brand: '#1B88F5', // = theme.primary
  ink: '#0F172A', // = text.primary — texto forte / numeros
  muted: '#71717A', // = text.secondary — subtitulo
  faint: '#94A3B8', // = text.placeholder — metadados, contagens
  border: '#E4E4E7', // = theme.border
  card: '#FFFFFF',
  bg: '#F5F6F6', // = theme.background
  rowHover: '#F5F9FD',

  // Semanticos (significado de dado):
  pos: '#16A34A',
  posSoft: '#E5F5ED',
  neg: '#DC2626',
  negSoft: '#FBE9E7',
  warn: '#D97706',
  warnSoft: '#FCF1DD',
  info: '#1B88F5',
  infoSoft: '#E9F4FD',
  neutralSoft: '#EEF2F6',

  // Cor de AREA do modulo (so header / badge de modulo):
  area: '#7C5CE0',
  areaSoft: '#EDE9FE',

  // Glass (cartoes translucidos sobre o GlassPageBg — padrao do Financeiro):
  glass: 'rgba(255,255,255,0.72)',
  glassBorder: 'rgba(15,23,42,0.08)',
  glassShadow: '0 6px 24px -12px rgba(15,23,42,0.18)',
  glassBlur: 'saturate(140%) blur(10px)',
} as const;

export const RADII = { pill: '10px', card: '16px' } as const;
